import { bundleListQuerySchema } from '@flux/shared';
import { createRoute } from '@tanstack/react-router';
import { BundlesPage } from '@/features/bundles/bundles-page.js';
import { authenticatedRoute } from './authenticated.js';

/**
 * `/bundles` — liste des bundles (`02` §8). La création et l'édition vivent
 * sur leurs propres routes (`/bundles/nouveau`, `/bundles/$sku`) : plus de
 * dialogue. Seuls l'import CSV et « Tester un SKU » restent des surfaces
 * flottantes, et sous forme de tiroir.
 *
 * `validateSearch` reprend `bundleListQuerySchema` (`@flux/shared`) :
 * page/pageSize/sortBy/sortDir/search/enabled. Plus de `store` — les bundles
 * n'ont plus de composition par boutique.
 */
export const bundlesRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: '/bundles',
  validateSearch: (search: Record<string, unknown>) => bundleListQuerySchema.parse(search),
  component: BundlesPage,
});
